import { useMutation } from '@apollo/client';
import { queries } from './queries';

const useAnswerCounter = () =>
  useMutation(queries.answerCounter, {
    errorPolicy: 'all', // ingore errors since we don't have to manage errors for this call
  });

export default useAnswerCounter;
